export enum VerificationStatus {
  notVerified = 'not_verified',
  addressVerified = 'address_verified',
  kycVerified = 'kyc_verified',
  tier1Verified = 'tier1_verified',
  paymentVerified = 'payment_verified',
  DocSignVerified = 'doc_sign_verified',
  tier2Verified = 'tier2_verified',
}
